import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction, mapToQueryParams } from '@sophocles/utils';
import { Map } from 'immutable';

export const REQUEST_JOB_CONFIGURATIONS = 'REQUEST_JOB_CONFIGURATIONS';
function requestJobConfigurations() {
  return {
    type: REQUEST_JOB_CONFIGURATIONS,
  };
}

export const REQUEST_CUSTOMER_JOB_CONFIGURATION = 'REQUEST_CUSTOMER_JOB_CONFIGURATION';
function requestCustomerJobConfigurations(customerId) {
  return {
    type: REQUEST_CUSTOMER_JOB_CONFIGURATION,
    customerId,
  };
}

export function fetchJobConfigurationsWithFilters(filters) {
  return dispatch => {
    dispatch(requestJobConfigurations());
    return apiClient
      .get(`/project/jobconfiguration/?${mapToQueryParams(Map(filters))}`)
      .then(checkHttpStatus)
      .then(res => res.data.results)
      .catch(error => dispatch(genericErrorAction(error, REQUEST_JOB_CONFIGURATIONS)));
  };
}

export function fetchJobConfigurationForCustomer(customerId) {
  return dispatch => {
    dispatch(requestCustomerJobConfigurations(customerId));
    return apiClient
      .get(`/customers/${customerId}/jobconfiguration/`)
      .then(checkHttpStatus)
      .then(res => {
        const configs = res.data.results;
        if (configs.length === 0) {
          return {};
        }
        return configs[0];
      })
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CUSTOMER_JOB_CONFIGURATION)));
  };
}
